<template>
  <ConfirmationDialog
    ref="dialog"
    :cancel-button-text="$t('tender-details.archive-dialog.cancel')"
    :buttonText="$t('tender-details.archive-dialog.submit')"
    :is-danger="true"
    @execute="onSubmit"
    @cancel-click="closeDialog"
  >
    <template slot="content">
      {{ $tc('tender-details.archive-dialog.content', tendersLength) }}
    </template>
  </ConfirmationDialog>
</template>

<script>
import ConfirmationDialog from '@/components/page-admin-invites/ConfirmationDialog.vue';

export default {
  name: 'TenderArchiveDialog',
  components: {
    ConfirmationDialog,
  },
  props: {
    tendersLength: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  computed: {},
  methods: {
    openDialog() {
      this.$refs.dialog.openDialog();
    },
    closeDialog() {
      this.$emit('on-ignore');
      this.$refs.dialog.closeDialog();
    },
    onSubmit() {
      this.$emit('on-submit');
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss"></style>
